import React from "react";
import { DefaultOverview, DefaultTopics } from "./DefaultViews";
export const CommonUserProfileOverview = () => {
    return <DefaultOverview />;
};
export const CommonUserProfileTopics = () => {
    return <DefaultTopics />;
};
